module.exports = __webpack_public_path__ + "static/media/label-guide.20332e9a.png";